import { render, staticRenderFns } from "./ttshop_barteragree.vue?vue&type=template&id=f6ae446c&scoped=true&"
import script from "./ttshop_barteragree.vue?vue&type=script&lang=js&"
export * from "./ttshop_barteragree.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_barteragree.vue?vue&type=style&index=0&id=f6ae446c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ae446c",
  null
  
)

export default component.exports